module.exports = __webpack_public_path__ + "static/media/FROM_2PM_TO_7PM.58a8ed12.svg";